import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface CreateRequestConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  code: string;
  ministerCount: number;
  isSubmitting: boolean;
  onConfirm: () => void;
}

export function CreateRequestConfirmDialog({
  open,
  onOpenChange,
  code,
  ministerCount,
  isSubmitting,
  onConfirm,
}: CreateRequestConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Confirmar Creación de Solicitud</AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            <p>
              Se creará y enviará una nueva solicitud con los siguientes datos:
            </p>
            <div className="space-y-1 rounded-md bg-muted p-3 text-sm">
              <div>
                <span className="font-semibold">Código:</span> {code}
              </div>
              <div>
                <span className="font-semibold">Ministros seleccionados:</span>{" "}
                {ministerCount}
              </div>
            </div>
            <p className="text-sm text-muted-foreground">
              Esta acción no se puede deshacer. La solicitud se enviará automáticamente.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isSubmitting}>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} disabled={isSubmitting}>
            {isSubmitting ? "Creando..." : "Crear y Enviar"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
